const COOKIE_NAME = 'velko_auth_redirects';
const WINDOW_MS = 10_000;
const THRESHOLD = 3;

interface RedirectRecord {
  at: number;
  target: string;
}

function cookieDomain(): string {
  const hostname = window.location.hostname;
  return hostname === 'velko-pos.com' || hostname.endsWith('.velko-pos.com')
    ? '; Domain=.velko-pos.com'
    : '';
}

function cookieSecurity(): string {
  return window.location.protocol === 'https:' ? '; Secure' : '';
}

function readRecords(): RedirectRecord[] {
  const prefix = `${COOKIE_NAME}=`;
  const value = document.cookie
    .split('; ')
    .find((part) => part.startsWith(prefix))
    ?.slice(prefix.length);

  if (!value) return [];

  try {
    const parsed = JSON.parse(decodeURIComponent(value)) as RedirectRecord[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeRecords(records: RedirectRecord[]): void {
  const value = encodeURIComponent(JSON.stringify(records));
  document.cookie = `${COOKIE_NAME}=${value}; Max-Age=30; Path=/; SameSite=Lax${cookieDomain()}${cookieSecurity()}`;
}

export function clearAuthRedirectHistory(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE_NAME}=; Max-Age=0; Path=/; SameSite=Lax${cookieDomain()}${cookieSecurity()}`;
}

export function recordAuthRedirect(target: string): boolean {
  if (typeof document === 'undefined') return false;

  const now = Date.now();
  const recent = readRecords().filter((entry) => now - entry.at < WINDOW_MS);
  recent.push({ at: now, target });
  writeRecords(recent);

  return recent.length >= THRESHOLD;
}

export const AUTH_REDIRECT_THRESHOLD = THRESHOLD;
export const AUTH_REDIRECT_WINDOW_MS = WINDOW_MS;
